// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"chart-minimum"},"nodeName":"g","children":[{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M21 21H3V3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M7 4.00567C7 7.99233 7.99609 13.9999 13 14.0038C18.0039 14.0077 19 7.98833 19 4M6.99805 16.998H7.00195V17.002H6.99805V16.998ZM9.99805 16.998H10.002V17.002H9.99805V16.998ZM12.998 16.998H13.002V17.002H12.998V16.998ZM15.998 16.998H16.002V17.002H15.998V16.998ZM18.998 16.998H19.002V17.002H18.998V16.998Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-chart-minimum')
export default class ChartMinimumIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'chart-minimum',
    }
  }
}
